import * as React from 'react';
import { useCallback, useContext, useEffect } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { AppNavigatorParamsContext, AccountLink, AccountLinkProps } from '@/lib/navigation';

import { TicketCardHeader } from './TicketCardHeader';
import { TicketCardLeft } from './TicketCardLeft';
import { TicketCardRight } from './TicketCardRight';

export interface TicketContact {
  identifier: string;
  external_tags: object[];
}

export type TicketCardProps = {
  uuid: string;
  active: boolean;
} & JSX.IntrinsicElements['div'];

export const TicketCard = React.memo(({ uuid, active = false, ...divProps }: TicketCardProps) => {
  const params = useContext(AppNavigatorParamsContext);
  const { contact }: any = useSelector<any>((state) => state.ticket.data[uuid]) || {};
  const handler = useCallback<AccountLinkProps['handlePress']>((event, navigate) => {
    if (!active) navigate();
  }, [active]);

  useEffect(() => {
    if (window.LocalTime && typeof window.LocalTime.run === 'function') {
      window.LocalTime.run();
    }
  });
  return (
    <AccountLink path={`tickets/${uuid}`} params={params} handlePress={handler}>
      <div
        id={uuid}
        className={classNames('ticket', { 'with-tags': !!contact?.external_tags, active })}
        {...divProps} // eslint-disable-line react/jsx-props-no-spreading
      >
        <TicketCardHeader ticket={uuid} />
        <div className="ticket-body">
          <TicketCardLeft ticket={uuid} />
          <TicketCardRight ticket={uuid} />
        </div>
        <div className="ticket-overlay" />
      </div>
    </AccountLink>
  );
});
